import React from "react";
import Tr from "translations/Translations";
import Dialog from "components/Dialog";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import PapersGeneratorXmpUzpPresidentPaperContent from "./PapersGeneratorXmpUzpPresidentPaperContent";

const PapersGeneratorXmpUzpPresidentPaperPopup = (
    {
        onClose,
        demandId,
    }) => {

    return (<Dialog
        open
        maxWidth='md'
        onClose={onClose}
        dialogActions={<MultiButton buttons={[createButton(Tr('close'), onClose)]}/>}
    >
        <PapersGeneratorXmpUzpPresidentPaperContent demandId={demandId} />
    </Dialog>)
}

export default PapersGeneratorXmpUzpPresidentPaperPopup;